import { useAuth } from '../context/AuthContext';

// Library/Hostel/CLO-PLO are opt-in per school, switched on only by Super Admin
// (schools.library_enabled / hostel_enabled / clo_plo_enabled). The flags ride
// along on the logged-in user object (see authController.safeUser), so this is
// just a thin, memo-free accessor — no extra network round trip needed.
export const useSchoolModules = () => {
  const { user } = useAuth();
  return {
    libraryEnabled: !!user?.libraryEnabled,
    hostelEnabled:  !!user?.hostelEnabled,
    cloPloEnabled:  !!user?.cloPloEnabled,
  };
};
